import { render } from "./SmallTitle.vue?vue&type=template&id=f5f8c9c6"
import script from "./SmallTitle.vue?vue&type=script&lang=js"
export * from "./SmallTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__